import React from 'react';
import type { PrismicFrontPageBanner } from '../../../../types';
import {
  Banner,
  Title,
  SubTitle,
  Button,
  TextButton,
  BackgroundImage,
  Content,
} from './styles';
import { Clickable } from 'src/components/clickable';
import { useViewportContext } from '../../../../components/viewport/context';
import { CardActionArea } from '@prisjakt/ui/card';
import colorMap from '../../../editorial-content/components/slices/shared/color-map';
import { plainText } from 'src/areas/editorial-content/components/slices/rich-text';

export const FrontPageBanner = ({
  image,
  link,
  buttonText,
  title,
  subtitle,
  buttonColor,
  textColor,
}: PrismicFrontPageBanner) => {
  const isExternal = link?.startsWith('http');
  const { isMobile } = useViewportContext();
  const fontColor = colorMap(textColor);
  const subtitleText = plainText(subtitle);
  return (
    <Banner>
      <CardActionArea
        container={!isMobile ? Clickable : undefined}
        containerProps={{ to: link, isExternal }}
      >
        <BackgroundImage src={image.url}>
          <Content>
            <Title data={title} />
            <SubTitle>{subtitleText}</SubTitle>
            <Button
              container={isMobile ? Clickable : undefined}
              containerProps={{ to: link, isExternal }}
              style={{
                background: buttonColor,
              }}
            >
              <TextButton fontColor={fontColor.text}>{buttonText}</TextButton>
            </Button>
          </Content>
        </BackgroundImage>
      </CardActionArea>
    </Banner>
  );
};
